import { SocialProfileType } from '../../types'
import { socialProfileByStatus } from '.'

export const socialProfileById = (_id: string, profiles: SocialProfileType[]) => {
  const activeProfiles = socialProfileByStatus(['active', 'expired'], profiles)
  return activeProfiles.find((profile) => profile._id === _id)
}
